var map = {
	"./facebook.png": 4717,
	"./facebook_dark.png": 7464,
	"./instagram.png": 5306,
	"./instagram_hover.png": 55,
	"./old/facebook.png": 3159,
	"./old/facebook_light.png": 3803,
	"./old/instagram.png": 881,
	"./old/instagram_light.png": 8027,
	"./old/linkedin.png": 9660,
	"./old/linkedin_light.png": 3648,
	"./old/x.png": 6215,
	"./old/x_light.png": 4729,
	"./old/youtube.png": 9785,
	"./old/youtube_light.png": 5003,
	"./tiktok.png": 7824,
	"./tiktok_hover.png": 9558,
	"./x.png": 6341,
	"./x_hover.png": 9344,
	"./youtube.png": 7010,
	"./youtube_hover.png": 6420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5078;